import React from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import HelpLocation from '@base/common/HelpLocation';
import { helpConfig } from 'pro/config/help';
import { useHelpGroups } from 'mod/help/useHelpGroups';
import { TiledHelpGroups } from 'mod/help/TiledHelpGroups';
import { SiteSNS } from '@base/common/SiteSNS';
import { Copyright } from '@base/common/Copyright';

export type IPageFooterProps = {
    className?: string;
};

const PageFooter: React.FC<IPageFooterProps> = props => {
    const { className } = props;
    const helpGroups = useHelpGroups(helpConfig);

    return (
        <div className={cn(className, styles.footer)}>
            <div className="wrapper">
                <div className={cn(styles['footer-links'], 'flex')}>
                    <div className={styles.col1}>
                        <TiledHelpGroups className={styles.help} groups={helpGroups}/>
                    </div>
                    <div className={styles.col2}>
                        <HelpLocation className={styles.location}/>
                        <SiteSNS className={styles.sns}/>
                    </div>
                </div>
                <Copyright className={styles.copyright}/>
            </div>
        </div>
    )
};

export default PageFooter;
